var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2091_12331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2091_12331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85366 21C4.3439 21 3.90752 20.8187 3.54451 20.4562C3.1815 20.0936 3 19.6577 3 19.1486V6.18879C3 5.67966 3.1815 5.24381 3.54451 4.88124C3.90752 4.51868 4.3439 4.33739 4.85366 4.33739H13.1256L11.272 6.18879H4.85366V19.1486H17.8293V12.715L19.6829 10.8636V19.1486C19.6829 19.6577 19.5014 20.0936 19.1384 20.4562C18.7754 20.8187 18.339 21 17.8293 21H4.85366ZM15.211 4.86967L16.5317 6.16565L10.4146 12.2753V13.5944H11.7122L17.8524 7.46163L19.1732 8.75761L12.5 15.4458H8.56098V11.5116L15.211 4.86967ZM19.1732 8.75761L15.211 4.86967L17.528 2.55542C17.8988 2.18514 18.3429 2 18.8604 2C19.3778 2 19.8142 2.18514 20.1695 2.55542L21.4671 3.87454C21.8224 4.2294 22 4.66139 22 5.17052C22 5.67966 21.8224 6.11165 21.4671 6.4665L19.1732 8.75761Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.e8381737b30b42207fe313b349314a07.svg";
export { ForwardRef as ReactComponent };